var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"grid-x align-center"},[_c('div',{staticClass:"cell small-12"},[_c('h1',[_vm._v("Mina annonser")]),_c('MyAdList',{attrs:{"ads":_vm.myAds}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }